import { createContext, useContext, useState, useCallback, useEffect } from "react";

const CompareContext = createContext(null);
const MAX = 3;

export function CompareProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem("piccar_compare") || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem("piccar_compare", JSON.stringify(ids)); }, [ids]);

  const toggle = useCallback((id) => {
    setIds((prev) => {
      if (prev.includes(id)) return prev.filter((x) => x !== id);
      if (prev.length >= MAX) return prev;
      return [...prev, id];
    });
  }, []);

  const remove = useCallback((id) => setIds((prev) => prev.filter((x) => x !== id)), []);
  const clear = useCallback(() => setIds([]), []);
  const has = useCallback((id) => ids.includes(id), [ids]);

  return (
    <CompareContext.Provider value={{ ids, toggle, remove, clear, has, max: MAX, full: ids.length >= MAX }}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => useContext(CompareContext);
